import { motion } from "framer-motion";
import Story from "@/components/sections/Story";
import Safety from "@/components/sections/Safety";
import Process from "@/components/sections/Process";
import { IMG } from "@/data/content";

export default function About() {
  return (
    <div data-testid="page-about">
      {/* Page header */}
      <section className="relative py-20 md:py-32 overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <img src={IMG.ovenBaking} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-bg via-bg/85 to-bg" />
        </div>
        <div className="max-w-5xl mx-auto container-px text-center">
          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="eyebrow">Despre DOTAPAN</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="h-display text-4xl md:text-6xl text-text mt-4">
            Din Beclean, <em className="text-gold not-italic">cu mâinile noastre.</em>
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }} className="mt-6 text-base md:text-lg text-text-soft leading-relaxed max-w-2xl mx-auto">
            DOTAPAN este o brutărie cu suflet din Bistrița-Năsăud, fondată în 2019. Lucrăm pentru bucătării care nu acceptă compromisul.
          </motion.p>
        </div>
      </section>

      <Story />
      <Process />
      <Safety />
    </div>
  );
}
